import { render, staticRenderFns } from "./ProjectActions.vue?vue&type=template&id=0dfb9025&scoped=true&lang=pug&"
import script from "./ProjectActions.vue?vue&type=script&lang=js&"
export * from "./ProjectActions.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActions.vue?vue&type=style&index=0&id=0dfb9025&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfb9025",
  null
  
)

export default component.exports